import {
  FormItem,
  FormRadio,
  FormRadioGroup,
  NavigationModal
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'

type RegenerateEventsModalProps = {
  showPrompt: boolean
  setShowPrompt: (showPrompt: boolean) => void
  confirmNavigation: () => void
  type: string
  patternId?: string
  occurrences?: number
  regenerateMode: string
  setRegenerateMode: (value: string) => void
}

export enum RegenerateOptions {
  DO_NOT_UPDATE = 'do_not_update',
  UPDATE_VISITS = 'update_draft_only',
  UPDATE_ALL = 'update_all'
}

const RegenerateEventsModal = ({
  showPrompt,
  setShowPrompt,
  confirmNavigation,
  type,
  occurrences,
  regenerateMode,
  setRegenerateMode
}: RegenerateEventsModalProps) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    confirmNavigation()
  }

  return (
    <NavigationModal
      modalTitle={t('CHANGES_WILL', {
        occurrences,
        type
      })}
      modalContentText={t('EXISTING_ROTA_PATTERN', { variable: type })}
      modalConfirmText={t('CONFIRM')}
      modalCancelText={t('CANCEL')}
      showPrompt={showPrompt}
      confirmNavigation={handleConfirm}
      cancelNavigation={() => setShowPrompt(false)}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <FormItem label={<Text>{t('SELECT_HOW_TO')}</Text>} long>
        <FormRadioGroup
          defaultValue={regenerateMode}
          onChange={(e) => setRegenerateMode(e.target.value)}
        >
          <FormRadio
            value={RegenerateOptions.DO_NOT_UPDATE}
            text={t('DO_NOT_UPDATE')}
          />
          <FormRadio
            value={RegenerateOptions.UPDATE_VISITS}
            text={t('UPDATE_VISITS')}
          />
          <FormRadio
            value={RegenerateOptions.UPDATE_ALL}
            text={t('UPDATE_ALL')}
          />
        </FormRadioGroup>
      </FormItem>
    </NavigationModal>
  )
}

export default RegenerateEventsModal
